<div>
    <div class="ui grid">
        <div class="four wide column">
            <button class="ui icon button arrow-button" (click)="previousMonth()">
                <i class="arrow left icon"></i>
            </button>
        </div>
        <div class="eight wide column text-center">
            <h3 class="month">{{currentMonth + " " + currentYear}}</h3>
        </div>
        <div class="four wide column">
            <button class="ui icon button arrow-button" (click)="nextMonth()">
                <i class="arrow right icon"></i>
            </button>
        </div>
    </div>

    <div class="ui seven column grid text-center smartphone">
        <p class="column day">Lu</p>
        <p class="column day">Ma</p>
        <p class="column day">Me</p>
        <p class="column day">Je</p>
        <p class="column day">Ve</p>
        <p class="column day">Sa</p>
        <p class="column day">Di</p>
    </div>

    <div class="ui seven column grid text-center desktop">
        <p class="column day">Lundi</p>
        <p class="column day">Mardi</p>
        <p class="column day">Mercredi</p>
        <p class="column day">Jeudi</p>
        <p class="column day">Vendredi</p>
        <p class="column day">Samedi</p>
        <p class="column day">Dimanche</p>
    </div>

    <div class="ui seven column grid text-center">
        <leasing-empty-slot class="column slot" *ngFor="let emptySlot of emptySlotsBefore" [slot]="emptySlot"></leasing-empty-slot>
        <leasing-slot class="column slot"
                      *ngFor="let slot of calendar.Slots()"
                      [slot]="slot"
                      (selected)="onSlotSelected($event)">
        </leasing-slot>
        <leasing-empty-slot class="column slot" *ngFor="let emptySlot of emptySlotsAfter" [slot]="emptySlot"></leasing-empty-slot>
    </div>
</div>



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/userReservation/calendar/calendar.html